/**
 * Rod označení osoby na kartě týmu a tvar role garanta (vize F7.8, řez 07).
 *
 * Data rod nemají a nové pole kvůli němu nevzniká (vize §3): rod se ČTE z prvního slova
 * vlastního označení karty (`destination_teams.subtitle`), které redakce píše sama
 * („Garantka destinace Vietnam", „Specialistka na Maroko", „Průvodkyně"). Z označení se
 * bere JEN rod, nikdy slovo role: roli dál skládá tabulka typů sekcí
 * (`TEAM_SECTION_META` v `types/index.ts`) z typu karty a jejího vlastníka, takže
 * „Specialistka na Mexiko …" dává na kartě „Garantka destinace Mexiko".
 *
 * Modul z `types` nic neimportuje — `types/index.ts` čte `GUARANTOR_TITLE` odsud
 * a import opačným směrem by byl cyklus.
 */

export type RodOznaceni = "muzsky" | "zensky";

/** Slovo role garanta v obou rodech; jediný zdroj tvaru „Garant"/„Garantka". */
export const GUARANTOR_TITLE: Record<RodOznaceni, string> = {
  muzsky: "Garant",
  zensky: "Garantka",
};

/** Ženské přípony prvního slova označení (bez diakritiky, malými písmeny). */
const ZENSKE_PRIPONY = ["ka", "kyne"] as const;

/**
 * Rod označení karty: ženský, když první slovo `subtitle` (bez diakritiky, malými
 * písmeny) končí na `ka` nebo `kyne`; jinak — i u prázdného nebo chybějícího
 * označení — mužský, tedy tvar, který web nesl před řezem 07.
 */
export function rodOznaceni(subtitle: string | null | undefined): RodOznaceni {
  const prvniSlovo = (subtitle ?? "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim()
    .match(/^\p{L}+/u)?.[0];
  if (!prvniSlovo) return "muzsky";
  return ZENSKE_PRIPONY.some((pripona) => prvniSlovo.endsWith(pripona)) ? "zensky" : "muzsky";
}
